import { Link, useNavigate } from "react-router-dom";
import "../App.css";
import {
  ArrowCircleDownLeft,
  ArrowCircleDownRight,
  ArrowCircleUp,
  ArrowCircleUpLeft,
  ArrowCircleUpRight,
  MapPin,
  MoonStars,
  Repeat,
  Sun,
  SunHorizon,
  UserGear,
} from "@phosphor-icons/react";
// import IsLoginFunc from "./libs/isLoginFunc.js";
import { useCookies } from "react-cookie";
import { jwtDecode } from "jwt-decode";
import { useEffect, useState } from "react";
import detectLocation from "../libs/detectLocation";
import AdminCardHistory from "../component/AdminCardHistory";
import CardHistory from "../component/CardHistory";
import AdminCardLeave from "../component/AdminCardLeave";

function HomeAdmin() {
  function greetingBasedOnTime() {
    const now = new Date();
    const hours = now.getHours();

    if (hours >= 5 && hours < 12) {
      return "Good Morning"; // Pagi
    } else if (hours >= 12 && hours < 18) {
      return "Good Afternoon"; // Siang
    } else {
      return "Good Night"; // Malam
    }
  }
  function greetingEmot() {
    const now = new Date();
    const hours = now.getHours();

    if (hours >= 5 && hours < 12) {
      return 1; // Pagi
    } else if (hours >= 12 && hours < 18) {
      return 2; // Siang
    } else {
      return 3; // Malam
    }
  }

  // Contoh penggunaan
  const greetingMessage = greetingBasedOnTime();
  const gret= greetingEmot();

  const [namaGweh, setNamaGweh] = useState(null);
  const [cookies] = useCookies(["token"]);
  const navigate = useNavigate();

  // Menggunakan useEffect untuk navigasi
  useEffect(() => {
    if (
      !cookies.token ||
      cookies.token === null ||
      cookies.token === undefined
    ) {
      navigate("/login");
    } else {
      try {
        // Pastikan cookies.token adalah string dan valid
        const token = cookies.token;
        if (typeof token === "string" && token) {
          const userName = jwtDecode(token).email;
          fetch(`${process.env.REACT_APP_SERVER}/api/user/${userName}`);
          setNamaGweh(userName);
        } else {
          navigate("/login");
          throw new Error("Invalid token format");
        }
      } catch (error) {
        console.error("MASUK SINI 3");

        navigate("/login");
        console.error("Invalid tokenmm", error);
      }
    }
  }, [cookies.token, navigate]); // Menambahkan dependencies

  const today = new Date();
  const optionDate = { day: "numeric", month: "long", year: "numeric" };

  const todayFormatted = today.toLocaleDateString("en-GB", optionDate);
  const dayToday = today.toLocaleDateString("en-GB", { weekday: "long" });
  const thisMonthLong = today.toLocaleDateString("en-GB", { month: "long" });

  const dateToday = `${dayToday}, ${todayFormatted.split(",").join(" ")}`;

  const [data, setData] = useState([]);
  const [location, setLocation] = useState({ latitude: null, longitude: null });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (namaGweh !== null) {
      const response = fetch(`${process.env.REACT_APP_SERVER}/api/admin/home/${namaGweh}`)
        .then((response) => response.json())
        .then((data) => {
          setData(data);
        })
        .catch((error) => setError(`An error occurred: ${error}`))
        .finally(() => setLoading(false));
    }

    const getLocation = () => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude } = position.coords;
            setLocation({ latitude, longitude });
          },
          (error) => {
            setError(error.message);
          }
        );
      } else {
        setError("Geolocation is not supported by this browser.");
      }
    };

    getLocation();

    return () => {};
  }, [namaGweh]);

  if (loading) {
    return (
      <div className="relative min-h-svh bg-slate-100 text-black">
        <div className="pt-6 px-4 pb-28 flex flex-col gap-10">
          {/* Greetings */}
          <div className="flex justify-between items-center ">
            <div className="flex flex-col ">
              <p className="text-md text-gray-500 ">{greetingMessage}</p>
              <div className="font-bold text-lg">--</div>
            </div>
            <div className=" p-3 rounded-full bg-white shadow">
              {gret === 1 ? (
                <SunHorizon size={26} />
              ) : gret === 2 ? (
                <Sun size={26} />
              ) : (
                <MoonStars size={26} />
              )}
            </div>
          </div>
          <div className="flex justify-between items-center gap-4">
            <p className="text-xs font-semibold text-gray-600 ">{dateToday}</p>
            <div className=" rounded-full px-2 py-2 shadow  bg-green-700 flex items-center justify-center gap-2">
              <MapPin weight="fill" color="white" size={16} />
              <p className="text-xs font-extralight text-white whitespace-nowrap w-24 text-center ">
                --
              </p>
            </div>
          </div>
          {/* Status Features */}
          <div className="grid grid-cols-2 gap-4">
            <div className="py-2 px-3 gap-2 flex flex-col justify-between bg-slate-50 shadow rounded-2xl">
              <div className="flex gap-2 items-center">
                <ArrowCircleDownLeft
                  size={40}
                  weight="fill"
                  className=" text-green-700"
                />
                <div>
                  <p className="font-semibold text-sm whitespace-nowrap text-black">
                    Check In
                  </p>
                  <p className="text-gray-400 font-medium text-xs">Count</p>
                </div>
              </div>
              <p className="font-bold text-black text-2xl">--</p>
            </div>
            <div className="py-2 px-3 gap-2 flex flex-col justify-between bg-slate-50 shadow rounded-2xl">
              <div className="flex gap-2 items-center">
                <ArrowCircleUpRight
                  size={40}
                  weight="fill"
                  className=" text-green-700"
                />
                <div>
                  <p className="font-semibold text-sm whitespace-nowrap text-black">
                    Check Out
                  </p>
                  <p className="text-gray-400 font-medium text-xs">Count</p>
                </div>
              </div>
              <p className="font-bold text-black text-2xl">--</p>
            </div>
            <div className="py-2 px-3 bg-slate-50 flex flex-col justify-between gap-2 shadow rounded-2xl">
              <div className="flex gap-2 items-center">
                <ArrowCircleUp
                  size={40}
                  weight="fill"
                  className=" text-green-700"
                />
                <div>
                  <p className="font-semibold text-sm text-black">Leave</p>
                  {/* Month */}
                  <p className="text-gray-400 font-medium text-xs">
                    {thisMonthLong}
                  </p>
                </div>
              </div>
              <div className="flex gap-2 items-center">
                <p className="font-bold text-black text-2xl">--</p>
                <span className="text-gray-400 font-semibold text-sm"></span>
              </div>
            </div>
            <div className="py-2 px-3 bg-slate-50 flex flex-col justify-between gap-2 shadow rounded-2xl">
              <div className="flex gap-2 items-center">
                <div className="p-2 bg-green-700 rounded-full">
                  <Repeat size={17} weight="bold" className=" text-white" />
                </div>
                <div>
                  <p className="font-semibold text-sm whitespace-nowrap text-black">
                    Total Attended
                  </p>
                  {/* Month */}
                  <p className="text-gray-400 font-medium text-xs">
                    {thisMonthLong}
                  </p>
                </div>
              </div>
              <div className="flex gap-2 items-center">
                <p className="font-bold text-black text-2xl">--</p>
                <span className="text-gray-400 font-normal"></span>
              </div>
            </div>
          </div>
          {/* Attend History */}
          <div className="flex justify-between items-center">
            <p className="text-lg font-bold">Attendance History</p>
            <Link
              to={"/analytics"}
              className="font-semibold text-sm text-green-600 cursor-pointer"
            >
              See More
            </Link>
          </div>
          <div className="-mt-6 flex flex-col gap-3">
            <div className="p-2 rounded-lg shadow flex gap-6 bg-slate-50">
              <div className="px-6 py-2 justify-center items-center flex flex-col min-h-[5.25rem] skeleton min-w-[4.5rem] text-white  bg-gray-200 rounded-lg gap-3">
                <p className={"text-2xl font-bold opacity-0 "}>22</p>
                <p className="text-sm font-light opacity-0">22</p>
              </div>
              {/* BUILD TIME STATUS */}
              <div className="pt-1.5 flex justify-between gap-2 flex-col w-full">
                <div className="flex justify-evenly ">
                  <div className="flex flex-col gap-0.5 items-center justify-center">
                    <p className="text-md font-semibold w-10 h-4 skeleton bg-gray-100 ">
                      {/* {getIndochinaTime(cb.check_in)} */}
                    </p>
                    <p className="text-xs font-normal text-gray-400">
                      Check In
                    </p>
                  </div>
                  <div className="border-s border-gray-400 h-full"></div>
                  <div className="flex flex-col gap-0.5 items-center justify-center ">
                    <p className="text-md font-semibold w-10 h-4 skeleton bg-gray-100 ">
                      {/* {getIndochinaTime(cb.check_out)} */}
                    </p>
                    <p className="text-xs font-normal text-gray-400">
                      Check Out
                    </p>
                  </div>
                  <div className="border-s border-gray-400 h-full"></div>
                  <div className="flex flex-col gap-0.5 items-center justify-center">
                    <p className="text-md font-semibold w-10 h-4 skeleton bg-gray-100 ">
                      {/* {timeDifference(cb.check_in, cb.check_out)} */}
                    </p>
                    <p className="text-xs font-normal text-gray-400">
                      Total Hours
                    </p>
                  </div>
                </div>
                <div className="flex  justify-center items-center">
                  <div className="gap-1.5 w-64 skeleton h-4 bg-gray-100"></div>
                </div>
              </div>
            </div>
            <div className="p-2 rounded-lg shadow flex gap-6 bg-slate-50">
              <div className="px-6 py-2 justify-center items-center flex flex-col min-h-[5.25rem] skeleton min-w-[4.5rem] text-white  bg-gray-200 rounded-lg gap-3">
                <p className={"text-2xl font-bold opacity-0 "}>22</p>
                <p className="text-sm font-light opacity-0">22</p>
              </div>
              {/* BUILD TIME STATUS */}
              <div className="pt-1.5 flex justify-between gap-2 flex-col w-full">
                <div className="flex justify-evenly ">
                  <div className="flex flex-col gap-0.5 items-center justify-center">
                    <p className="text-md font-semibold w-10 h-4 skeleton bg-gray-100 ">
                      {/* {getIndochinaTime(cb.check_in)} */}
                    </p>
                    <p className="text-xs font-normal text-gray-400">
                      Check In
                    </p>
                  </div>
                  <div className="border-s border-gray-400 h-full"></div>
                  <div className="flex flex-col gap-0.5 items-center justify-center ">
                    <p className="text-md font-semibold w-10 h-4 skeleton bg-gray-100 ">
                      {/* {getIndochinaTime(cb.check_out)} */}
                    </p>
                    <p className="text-xs font-normal text-gray-400">
                      Check Out
                    </p>
                  </div>
                  <div className="border-s border-gray-400 h-full"></div>
                  <div className="flex flex-col gap-0.5 items-center justify-center">
                    <p className="text-md font-semibold w-10 h-4 skeleton bg-gray-100 ">
                      {/* {timeDifference(cb.check_in, cb.check_out)} */}
                    </p>
                    <p className="text-xs font-normal text-gray-400">
                      Total Hours
                    </p>
                  </div>
                </div>
                <div className="flex  justify-center items-center">
                  <div className="gap-1.5 w-64 skeleton h-4 bg-gray-100"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  } else if (error) return <div>Error: {error}</div>;

  const isInLocation = detectLocation(location.latitude, location.longitude);
  const locationRightNow = isInLocation ? "In Dhoho TV" : "Outside Dhoho TV";
  const thisIsUser = data.payload.datas.user.datas;

  const checkInCrewCount =
    data.payload.datas.attendanceToday !== undefined
      ? data.payload.datas.attendanceToday.datas.filter(
          (cb) => cb.is_acc === 1 && cb.kehadiran === "H"
        ).length
      : 0;
  const checkOutCrewCount =
    data.payload.datas.attendanceToday !== undefined
      ? data.payload.datas.attendanceToday.datas.filter(
          (cb) =>
            cb.is_acc === 1 && cb.kehadiran === "H" && cb.check_out !== null
        ).length
      : 0;
  const leaveTodayCrewCount =
    data.payload.datas.leaveToday !== undefined
      ? data.payload.datas.leaveToday.datas.filter((cb) => cb.is_acc === 1)
          .length
      : 0;
  const leaveTodayRequestCrewCount =
    data.payload.datas.leaveToday !== undefined
      ? data.payload.datas.leaveToday.datas.filter((cb) => cb.is_acc === 0)
          .length
      : 0;
  const AttendanceTodayRequestCrewCount =
    data.payload.datas.leaveToday !== undefined
      ? data.payload.datas.attendanceToday.datas.filter((cb) => cb.is_acc === 0)
          .length
      : 0;

  const checkInCrewPermission =
    data.payload.datas.attendanceToday !== undefined
      ? data.payload.datas.attendanceToday.datas.filter(
          (cb) => cb.is_acc === 0 && cb.kehadiran === "H"
        )
      : [];
  const inWorksCrew =
    data.payload.datas.attendanceToday !== undefined
      ? data.payload.datas.attendanceToday.datas.filter(
          (cb) =>
            cb.is_acc === 1 && cb.kehadiran === "H" && cb.check_out === null
        )
      : [];
  const historyTodayCrew =
    data.payload.datas.attendanceToday !== undefined
      ? data.payload.datas.attendanceToday.datas.filter(
          (cb) =>
            cb.is_acc === 1 && cb.kehadiran === "H" && cb.check_out !== null
        )
      : [];
  const leaveTodayCrew =
    data.payload.datas.leaveToday !== undefined
      ? data.payload.datas.leaveToday.datas.filter((cb) => cb.is_acc === 1)
      : [];
  const leaveTodayRequestCrew =
    data.payload.datas.leaveToday !== undefined
      ? data.payload.datas.leaveToday.datas.filter((cb) => cb.is_acc === 0)
      : [];

  return (
    <div className="relative min-h-svh bg-slate-100 text-black">
      <div className="pt-6 px-4 pb-28 flex flex-col gap-10">
        {/* Greetings */}
        <div className="flex justify-between items-center ">
          <div className="flex flex-col ">
            <p className="text-md text-gray-500">{greetingMessage}</p>
            <p className="font-bold text-lg">{thisIsUser.name}</p>
          </div>
          <div className=" p-3 rounded-full bg-white shadow">
            {gret === 1 ? (
                <SunHorizon size={26} />
              ) : gret === 2 ? (
                <Sun size={26} />
              ) : (
                <MoonStars size={26} />
              )}
          </div>
        </div>
        <div className="flex justify-between items-center gap-4">
          <p className="text-xs font-semibold text-gray-600">{dateToday}</p>
          <div className=" rounded-full px-4 py-2 shadow  bg-green-700 flex items-center justify-center gap-2">
            <MapPin weight="fill" color="white" size={16} />
            <p className="text-xs font-extralight text-white whitespace-nowrap">
              {locationRightNow}
            </p>
          </div>
        </div>
        {/* Status Features */}
        <div className="grid grid-cols-2 gap-4">
          <div className="py-2 px-3 gap-2 flex flex-col justify-between bg-slate-50 shadow rounded-2xl">
            <div className="flex gap-2 items-center">
              <ArrowCircleDownLeft
                size={40}
                weight="fill"
                className=" text-green-700"
              />
              <div>
                <p className="font-semibold text-sm whitespace-nowrap text-black">
                  Check In
                </p>
                <p className="text-gray-400 font-medium text-xs">Count</p>
              </div>
            </div>
            <div className="flex gap-2 items-center">
              <p className="font-bold text-black text-2xl">
                {checkInCrewCount}
              </p>
              <span className="text-gray-400 font-semibold text-sm">
                Person
              </span>
            </div>
          </div>
          <div className="py-2 px-3 gap-2 flex flex-col justify-between bg-slate-50 shadow rounded-2xl">
            <div className="flex gap-2 items-center">
              <ArrowCircleUpRight
                size={40}
                weight="fill"
                className=" text-green-700"
              />
              <div>
                <p className="font-semibold text-sm whitespace-nowrap text-black">
                  Check Out
                </p>
                <p className="text-gray-400 font-medium text-xs">Count</p>
              </div>
            </div>
            <div className="flex gap-2 items-center">
              <p className="font-bold text-black text-2xl">
                {checkOutCrewCount}
              </p>
              <span className="text-gray-400 font-semibold text-sm">
                Person
              </span>
            </div>
          </div>
          <div className="py-2 px-3 bg-slate-50 flex flex-col justify-between gap-2 shadow rounded-2xl">
            <div className="flex gap-2 items-center">
              <ArrowCircleUp
                size={40}
                weight="fill"
                className=" text-green-700"
              />
              <div>
                <p className="font-semibold text-sm text-black">Leave</p>
                {/* Month */}
                <p className="text-gray-400 font-medium text-xs">Count</p>
              </div>
            </div>
            <div className="flex gap-2 items-center">
              <p className="font-bold text-black text-2xl">
                {leaveTodayCrewCount}
              </p>
              <span className="text-gray-400 font-semibold text-sm">
                Person
              </span>
            </div>
          </div>
          <div className="py-2 px-3 bg-slate-50 flex flex-col justify-between gap-2 shadow rounded-2xl">
            <div className="flex gap-2 items-center">
              <div className="p-2 bg-green-700 rounded-full">
                <UserGear size={17} weight="bold" className=" text-white" />
              </div>
              <div>
                <p className="font-semibold text-sm whitespace-nowrap text-black">
                  Active
                </p>
                {/* Month */}
                <p className="text-gray-400 font-medium text-xs">In Job</p>
              </div>
            </div>
            <div className="flex gap-2 items-center">
              <p className="font-bold text-black text-2xl">
                {leaveTodayRequestCrewCount}
              </p>
              <span className="text-gray-400 font-normal">Person</span>
            </div>
          </div>

          <div className="py-2 px-3 gap-2 flex flex-col justify-between bg-slate-50 shadow rounded-2xl">
            <div className="flex gap-2 items-center">
              <ArrowCircleUpLeft
                size={40}
                weight="fill"
                className=" text-green-700"
              />
              <div>
                <p className="font-semibold text-sm whitespace-nowrap text-black">
                  Attendance
                </p>
                <p className="text-gray-400 font-medium text-xs">Request</p>
              </div>
            </div>
            <div className="flex gap-2 items-center">
              <p className="font-bold text-black text-2xl">
                {AttendanceTodayRequestCrewCount}
              </p>
              <span className="text-gray-400 font-semibold text-sm">
                Person
              </span>
            </div>
          </div>
          <div className="py-2 px-3 gap-2 flex flex-col justify-between bg-slate-50 shadow rounded-2xl">
            <div className="flex gap-2 items-center">
              <ArrowCircleDownRight
                size={40}
                weight="fill"
                className=" text-green-700"
              />
              <div>
                <p className="font-semibold text-sm whitespace-nowrap text-black">
                  Leave
                </p>
                <p className="text-gray-400 font-medium text-xs">Request</p>
              </div>
            </div>
            <div className="flex gap-2 items-center">
              <p className="font-bold text-black text-2xl">
                {leaveTodayRequestCrewCount}
              </p>
              <span className="text-gray-400 font-semibold text-sm">
                Person
              </span>
            </div>
          </div>
        </div>
        <div className="flex justify-between items-center">
            <Link to={"/history/announcement"} className="text-sm font-semibold cursor-pointer bg-amber-500 text-white px-4 py-1 rounded-full">Announcement</Link>
            <Link
              to={"/history/report"}
              className="font-semibold text-sm px-4 py-1 text-white rounded-full bg-red-600 cursor-pointer"
            >
              Report
            </Link>
          </div>

        
        {/* <div className="flex justify-end items-center gap-4">
          <div onClick={activeAddLogistic} className=" cursor-pointer rounded-full px-6 py-2 shadow  bg-green-700 border border-green-700 flex items-center justify-center gap-2">
            <Toolbox weight="fill" color="white" size={16} />
            <p className="text-xs font-extralight text-white whitespace-nowrap">
              Analytics
            </p>
          </div>
          {/* <AddLogistics isVisible={isVisible} onClose={onClose} last_user_id={id_user} location_logistics_cords={coords} location_logistics_name={location} /> *
        </div> */}
        {/* Attend History */}
        {checkInCrewPermission.length > 0 && (
          <>
            <div className="flex justify-between items-center">
              <p className="text-lg font-bold">Request Attedance</p>
            </div>
            <div className="-mt-6 grid xl:grid-cols-2  gap-3">
              {/* Card */}
              {checkInCrewPermission.map((cb, i) => {
                {
                  return (
                    <AdminCardHistory
                      cb={cb}
                      api={
                        process.env.REACT_APP_SERVER +
                        "/api/admin/confirm-attend"
                      }
                      key={i}
                    />
                  );
                }
              })}
            </div>
          </>
        )}
        {leaveTodayRequestCrew.length > 0 && (
          <>
            <div className="flex justify-between items-center">
              <p className="text-lg font-bold">Request Leave</p>
            </div>
            <div className="-mt-6 grid xl:grid-cols-2  gap-3">
              {/* Card */}
              {leaveTodayRequestCrew.map((cb, i) => {
                {
                  return (
                    <AdminCardLeave
                      cb={cb}
                      api={
                        process.env.REACT_APP_SERVER +
                        "/api/admin/confirm-leave"
                      }
                      key={i}
                    />
                  );
                }
              })}
            </div>
          </>
        )}
        {inWorksCrew.length > 0 && (
          <>
            <div className="flex justify-between items-center">
              <p className="text-lg font-bold">Works Crew</p>
            </div>
            <div className="-mt-6 grid xl:grid-cols-2  gap-3">
              {/* Card */}
              {inWorksCrew.map((cb, i) => {
                {
                  return <AdminCardHistory cb={cb} key={i} />;
                }
              })}
            </div>
          </>
        )}
        {historyTodayCrew.length > 0 && (
          <>
            <div className="flex justify-between items-center">
              <p className="text-lg font-bold">Attendance Crew Today</p>
            </div>
            <div className="-mt-6 grid xl:grid-cols-2 gap-3">
              {/* Card */}
              {historyTodayCrew.map((cb, i) => {
                {
                  return <CardHistory cb={cb} key={i} />;
                }
              })}
            </div>
          </>
        )}
        {leaveTodayCrew.length > 0 && (
          <>
            <div className="flex justify-between items-center">
              <p className="text-lg font-bold">Leave Crew Today</p>
            </div>
            <div className="-mt-6 grid xl:grid-cols-2  gap-3">
              {/* Card */}
              {leaveTodayCrew.map((cb, i) => {
                {
                  return <AdminCardLeave cb={cb} key={i} />;
                }
              })}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default HomeAdmin;

export function getIndochinaTime(prms) {
  const today = new Date(prms); // Waktu saat ini dalam UTC
  const utcOffset = today.getTimezoneOffset(); // Offset dalam menit
  const indochinaOffset = -420; // GMT+7 offset dalam menit

  // Menghitung selisih antara UTC dan Indochina
  const timeDifference = indochinaOffset - utcOffset;
  const indochinaTime = new Date(today.getTime() + timeDifference * 60 * 1000); // Mengonversi ke milidetik

  return indochinaTime.toLocaleString("id-ID", {
    timeZone: "Asia/Jakarta",
    hour: "2-digit",
    minute: "2-digit",
  }); // Format HH:mm
}

export function timeDifference(date1, date2) {
  // Mengonversi parameter menjadi objek Date jika bukan sudah dalam bentuk Date
  const startTime = new Date(date1);
  const endTime = new Date(date2);

  // Menghitung selisih waktu dalam milidetik
  const differenceInMilliseconds = endTime - startTime;

  // Menghitung jam dan menit dari selisih waktu
  const totalMinutes = Math.floor(differenceInMilliseconds / (1000 * 60));
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  // Format menjadi HH:MM
  const formattedTimeDifference = `${String(hours).padStart(2, "0")}:${String(
    minutes
  ).padStart(2, "0")}`;

  return formattedTimeDifference;
}
